var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32216 1.25873C1.84286 0.762714 2.68708 0.762714 3.20778 1.25873L10.265 7.98141L17.3222 1.25873C17.8429 0.762714 18.6871 0.762714 19.2078 1.25873C19.7285 1.75475 19.7285 2.55895 19.2078 3.05497L12.1506 9.77765L19.2078 16.5003C19.7285 16.9963 19.7285 17.8005 19.2078 18.2966C18.6871 18.7926 17.8429 18.7926 17.3222 18.2966L10.265 11.5739L3.20778 18.2966C2.68708 18.7926 1.84286 18.7926 1.32216 18.2966C0.801466 17.8005 0.801466 16.9963 1.32216 16.5003L8.37936 9.77765L1.32216 3.05497C0.801466 2.55895 0.801466 1.75475 1.32216 1.25873Z",
    fill: "#3F3F55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.601ba64cacef7b82ddb7a799fc3ef7dc.svg";
export { ForwardRef as ReactComponent };